export default __webpack_public_path__ + "static/media/walletIcon.92105e88.svg";